<template>
  <div class="cell" @click="gotoArticle">
    <img class="img" :src="item.bbsImgName" />
    <div class="cell-con">
      <div class="title">{{ item.bbsTitle }}</div>
      <div class="summary">{{ item.bbsDigest }}</div>
      <div class="comment">
        <div class="read">{{ item.bbsReadNum }}人阅读</div>
        <div class="date">{{ date }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    date() {
      return this.item.bbsDate.substring(0, 10)
    }
  },
  methods: {
    gotoArticle () {
      let authToken = this.$cookies.get('authToken')
      let VUE_APP_KNOWLEDGE_H5_URL = process.env.VUE_APP_KNOWLEDGE_H5_URL
      let path = VUE_APP_KNOWLEDGE_H5_URL + `?id=${this.item.bbsId} & authToken=${authToken}`
      window.location.href = path
    }
  }
}
</script>

<style lang="less" scoped>
.cell {
  height: 82px;
  width: 100%;
  margin: 10px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  .img {
    width: 130px;
    height: 100%;
    border-radius: 4px;
    object-fit: cover;
    background: #FAFAFA;
  }
  .cell-con {
    height: 83%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    margin: 4px 12px 10px 12px;
    .title {
      font-size: 10px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 15px;
    }
    .summary {
      font-size: 7px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #888888;
      line-height: 10px;
      margin-bottom: 12px;
    }
    .comment {
      font-size: 6px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #888888;
      line-height: 9px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .date {
        margin-left: 10px;
      }
    }
  }
}
</style>